import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import Problem from "@/sections/Problem";
import Approach from "@/sections/Approach";
import WhoIHelp from "@/sections/WhoIHelp";
import OperatingSystems from "@/sections/OperatingSystems";
import Services from "@/sections/Services";
import About from "@/sections/About";
import FinalCTA from "@/sections/FinalCTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Problem />
      <Approach />
      <WhoIHelp />
      <OperatingSystems />
      <Services />
      <About />
      <FinalCTA />
    </main>
  );
}
